export class ShiftTasksReactBridge {
  constructor(TaskTemplatesService, ShiftTasksService) {
    'ngInject';

    Object.assign(this, { TaskTemplatesService, ShiftTasksService });
  }

  onAddTaskTemplate(template) {
    this.TaskTemplatesService.onCreateSuccess(template);
  }

  onEditTaskTemplate(template) {
    this.TaskTemplatesService.onEditSuccess(template);
  }

  onEditTaskInstance(instance) {
    this.ShiftTasksService.onEditTaskInstanceSuccess(instance);
  }
}
